import { PacketIn } from "./PacketIn.js";
import { InboundPacketType } from "./InboundPacketType.js";
import { readJsonString } from "../../../../util/json.js";
import type { MessageIOContext } from "../../../api/MessageIOContext.js";


export class PacketInSetID extends PacketIn {
    public static readonly ID_KEY = "id";

    public id: string | null = null;

    constructor() {
        super(InboundPacketType.SET_ID);
    }

    override readContents(_context: MessageIOContext, json: Record<string, any>): void {
        this.id = readJsonString(json, PacketInSetID.ID_KEY);
    }
}
